import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { CloudStagingListDataProviderFactory } from '../factory/CloudStagingListDataProviderFactory';
import { CloudStagingListNirvanaDataProvider } from '../dataProvider/CloudStagingListNirvanaDataProvider';

export class CloudStagingListRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CloudStagingListDataProviderFactory;
  public dataProvider: CloudStagingListNirvanaDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CloudStagingListDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async updatePinnedVersion(type: number, newStagingProfiles: Array<number>, version: string): Promise<any> {
    return this.dataProvider.updatePinnedVersion(type, newStagingProfiles, version);
  }
}
